/*
* @描述: 公共头部
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2022-11-23 17:39:54
*/
<template>
    <div class="page_header">
        <div class="user_info_wrap">
          <div class="info_box">
            <el-avatar size="small"
                       class="user_avatar"
                       icon="el-icon-user-solid"
                       v-if="!userInfo.avatar||userInfo.avatar==='/Public/images/default.jpg'">
            </el-avatar>
            <el-avatar size="small"
                       :src="userInfo.avatar"
                       class="user_avatar"
                       v-else>
            </el-avatar>
            <span class="user_name" v-text="userInfo.name"></span>
          </div>
            <div class="login_out" @click="handleClickLoginOut">
                <i class="el-icon-switch-button"></i>
                <span>退出</span>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import router from "../../router";
import {Message} from "element-ui";
export default {
    name: 'Header',
    data () {
        return {
        }
    },
    created () {
      const vuex = JSON.parse(localStorage.getItem('vuex'))
      if (!vuex || !vuex.userInfo.ticket) {
        localStorage.removeItem('vuex')
        router.replace('/login')
      }
    },
    computed: {
        ...mapState(['userInfo'])
    },
    mounted () {
    },
    methods: {
        handleClickLoginOut () {
            this.$confirm('确定退出系统吗？', '提示', {
                type: 'error',
                closeOnClickModal: false,
                closeOnPressEscape: false,
            }).then(() => {
                localStorage.clear()
                this.$router.replace('/login')
            }).catch(() => {

            })
        },
    },
    components: {

    }
}
</script>

<style lang="scss" scoped>
.page_header {
    width: 100%;
    height: 68px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #ffffff;
    border-bottom: 1px solid #e7eaec;

    .user_info_wrap {
        height: 100%;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        .el-icon-bell {
            font-size: 18px;
            cursor: pointer;
            margin: 0 10px;
        }

        .login_out, .info_box {
            height: 60px;
            line-height: 60px;
            padding: 0 20px;
            cursor: pointer;
            transition: background-color .3s;

            &:hover {
                background-color: #eeeeee;
            }

            .user_avatar {
                vertical-align: middle;
                margin-right: 10px;
            }

            .el-icon-switch-button, .el-icon-edit-outline {
                margin-right: 10px;
                font-size: 16px;
            }

            .user_name {
                vertical-align: middle;
            }
        }
    }
}
</style>
